import {GetStatesMedicalGuide} from 'domain/usecases';
import {RemoteGetStatesMedicalGuide} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {GuideFlowEndpoints} from 'main/factories/usecases/endpoints';

export const makeGetStatesMedicalGuide = (): GetStatesMedicalGuide =>
	new RemoteGetStatesMedicalGuide(
		makeBFFApiUrl(GuideFlowEndpoints.medicalGuideStates),
		makeAuthorizeHttpClientDecorator(),
	);
